import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './SortableHeader.scss';
import SortableHeaderField from 'components/controls/SortableHeaderField';

export default function SortableHeader(props) {
  const getNextDirection = direction => {
    switch (direction) {
      case 1: return -1;
      case 0: return 1;
      case -1: return 0;
    }
  };

  const changeDirection = sort => {
    const newDirection = getNextDirection(sort.direction);
    if (newDirection === 0) {
      props.onChange();

      return;
    }

    props.onChange({[sort.name]: getNextDirection(sort.direction)});
  };

  const renderField = (field, key) => {
    if (!field) {
      return null;
    }

    const {current} = props;

    return (
      <SortableHeaderField
        key={key}
        current={current}
        field={field}
        onChangeDirection={changeDirection}
      />
    );
  };

  return (
    <div className={classnames(styles.container, props.className)}>
      {props.fields.map(renderField)}
    </div>
  );
}

SortableHeader.propTypes = {
  current: PropTypes.object,
  fields: PropTypes.array,
  onChange: PropTypes.func.isRequired,
};

SortableHeader.defaultProps = {
  current: {},
  fields: [],
};


// WEBPACK FOOTER //
// ./src/components/controls/SortableHeader.jsx